import { z } from 'zod';
import { MAX_DIMENSION, MAX_GIF_FPS, MIN_DIMENSION, MIN_GIF_FPS } from '@/constants/media';

/**
 * Validates the settings form. Inputs arrive as strings from the DOM, so
 * numeric fields coerce; bounds mirror what the conversion plan will accept
 * so nothing invalid can reach ffmpeg.
 */
export const settingsSchema = z.object({
  sizePreset: z.enum(['auto', 'original', '480', '360', '240', 'custom']),
  customWidth: z.coerce
    .number({ invalid_type_error: 'Enter a width in pixels.' })
    .int('Whole pixels only.')
    .min(MIN_DIMENSION, `At least ${MIN_DIMENSION} px.`)
    .max(MAX_DIMENSION, `At most ${MAX_DIMENSION} px.`),
  customHeight: z.coerce
    .number({ invalid_type_error: 'Enter a height in pixels.' })
    .int('Whole pixels only.')
    .min(MIN_DIMENSION, `At least ${MIN_DIMENSION} px.`)
    .max(MAX_DIMENSION, `At most ${MAX_DIMENSION} px.`),
  lockAspect: z.boolean(),
  fps: z.coerce
    .number()
    .int()
    .min(MIN_GIF_FPS, `At least ${MIN_GIF_FPS} fps.`)
    .max(MAX_GIF_FPS, `GIF tops out around ${MAX_GIF_FPS} fps.`),
  quality: z.enum(['high', 'balanced', 'compact']),
  speed: z.coerce.number().min(0.25).max(4),
  loopForever: z.boolean(),
  dither: z.enum(['auto', 'floyd', 'bayer', 'none']),
  dropDuplicates: z.boolean(),
});

export type SettingsFormValues = z.infer<typeof settingsSchema>;
